/**
 *
 */
const style = theme => ({
    statements: {
        maxWidth: '900px',
        margin: ({ screenSize }) => screenSize.mobile ? '10px' : '40px auto 0 auto'
    },
    table: {
        minWidth: '75%',
        maxWidth: '100%'
    },
    tableHead: {
        '& th': {
            '&:not(:last-child)': {
                paddingRight: '20px'
            },
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: '20px',
            fontFamily: 'Inter',
            color: theme['foundations-library'].colors.secondary[500],
            textTransform: 'uppercase',
            height: '34px',
            borderBottom: '1px solid rgba(28, 153, 128, 0.5)',
            borderTop: '1px solid rgba(28, 153, 128, 1)',
            minWidth: ({ screenSize }) => !screenSize.mobile && '100px',
            whiteSpace: 'nowrap',
            '& .table-head--icon': {
                width: 24,
                height: 24
            }
        }
    },
    tableBody: {
        '& tr': {
            boxShadow: '0px -1px 0px 0px rgba(133, 146, 154, 0.2) inset',
            height: '62px',
            '& td': {
                ...theme['foundations-library'].typography.body3,
                color: theme['foundations-library'].colors.neutral[900],
                '&:not(:last-child)': {
                    paddingRight: '20px'
                }
            }
        }
    },
    billingIcon: {
        marginRight: '8px'
    },
    downloadAllButtonWrapper: {
        marginBottom: '20px',
        textAlign: 'right'
    },
    getFileFromListButton: {
        cursor: 'pointer'
    }
})

export default style
